<template>
  <div
    id="preview-publish"
    class="d-flex align-center">
    <!-- Preview / Publish -->
    <v-btn
      @click="previewModalOpen = true;"
      class="margin-right"
      color="primary"
      type="button"
      outlined
      block>
      Preview
    </v-btn>

    <v-btn
      @click="publishSite"
      color="success"
      type="button"
      outlined
      block>
      Publish
    </v-btn>
    <!-- / Preview / Publish -->

    <!-- Confirm Preview Dialog -->
    <v-dialog
      id="confirm-preview-dialog"
      ref="confirmPreviewDialog"
      v-model="previewModalOpen"
      width="500">
      <v-card>
        <v-card-title
          class="headline px-2 py-2"
          primary-title>
          Preview
        </v-card-title>

        <div class="px-2 pb-2">
          Are you sure you want to preview your changes?
        </div>

        <v-card-actions>
          <div>
            <v-checkbox
              id="generate-placeholders"
              name="generatePlaceholders"
              ref="generatePlaceholders"
              class="m-0"
              label="Generate Placeholders"
              height="28"
              v-model="generatePlaceholders">
            </v-checkbox>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            type="button"
            color="primary"
            @click="previewSite">
            Yes
          </v-btn>

          <v-btn
            type="button"
            class="ml-3"
            color="primary"
            outlined
            @click="previewModalOpen = false;">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Confirm Preview Dialog -->
  </div>
</template>

<script>
export default {
  name: 'PreviewPublish',
  data() {
    return {
      previewModalOpen: false,
      generatePlaceholders: false,
    };
  },
  methods: {
    previewSite() {
      this.$store.dispatch('preview', this.generatePlaceholders)
        .then((data) => {
          this.showLink(data);
          this.previewModalOpen = false;
          this.generatePlaceholders = false;
        });
    },
    publishSite() {
      this.showConfirm(
        'Are you sure you want to publish your changes to the public website?',
        'Publish',
      ).then(() => this.$store.dispatch('publish'), () => Promise.reject()).then(this.showLink, () => {});
    },
    showLink({ viewUrl }) {
      this.showWarning(
        `Click the link below to view your changes.<br><br>
        <a href="${viewUrl}" target="_blank">${viewUrl}</a>`,
        'Publish Link',
      );
    },
  },
};
</script>

<style lang="scss"></style>
